import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';

import styles from './style.scss';


const subscriptionTypeMapper = {
  1: 'standard',
  2: 'premium',
  3: 'premium',
};

const BookRentIncludeSubscription = ({ book }) => {
  const subscriptionType = subscriptionTypeMapper[get(book, 'subscription_id', 1)];
  const isAudio = get(book, 'type', '') === 'audio';
  const linkToBookText = isAudio ? 'Начать слушать' : 'Начать читать';

  return (
    <div className={classNames(styles.bookRentIncludeSubscription, 'jest-rented-book-included-subscription')}>
      <div className={styles.header}>
        <div className={classNames(
          styles.successImage,
          subscriptionType,
          `jest-rented-book-included-subscription-${subscriptionType}`
        )} />
        <div className={styles.headerText}>
          <span><b>У вас есть подписка</b></span>
        </div>
        <div className={styles.headerTitle}>
          <span>
            Вы уже оформили подписку, в которую входит эта {isAudio ? 'аудиокнига' : 'книга'}
          </span>
        </div>
      </div>
      <div className={styles.linkContainer}>
        <Link className="jest-link-to-user-books" to={{ pathname: book.absolute_url, state: { book } }}>
          <span className="link">
            {linkToBookText}
          </span>
          <span className={classNames('arrowRight', styles.arrow)} />
        </Link>
      </div>
    </div>
  );
};

BookRentIncludeSubscription.propTypes = {
  book: PropTypes.object,
  user: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
};

export default BookRentIncludeSubscription;
